import {GLOBAL_STATE, INPUT_TYPE} from "@/constants";

export function getInitialFormValues(inputs) {
	return inputs.map(input => {
		return {[input.name]: '', type: input.inputType}
	})
}

export function getGlobalFormSpreeEvnKey() {
	const key = process.env.NEXT_FORMSPREE_KEYS
	const parsedKey = JSON.parse(key)
	return parsedKey[GLOBAL_STATE] || 'blankkey'
}

export function extractExtraFormValues(formData) {
	return formData.reduce((acc, el) => {
		if (el.type === INPUT_TYPE.SELECT || el.type === INPUT_TYPE.VOIVODESHIP) {
			const firstKey = Object.keys(el)[0];
			acc[firstKey] = el[firstKey];
		}
		return acc;
	}, {});
};